export default __webpack_public_path__ + "static/media/34.30b577d2.svg";